// components/ErrorBoundary.tsx
import React, { ReactNode } from 'react';
import { Result, Button } from 'antd';
import {Translate} from "../util/translation.util";

interface ErrorBoundaryProps {
    children?: ReactNode;
    hasError?: boolean;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: props.hasError ?? false };
    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: any) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return (
                    <Result
                            status="500"
                            title={<Translate message={`global.title.error`} />}
                    />
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
